module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showWrap) ? _c('div', {
    staticClass: "wrap",
    class: _vm.showContent ? 'fadein' : 'fadeout'
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f871228a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/toast.vue
// module id = 1406
// module chunks = 1